import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import FilterDropdown from '../../../components/FilterDropdown/FilterDropdown';
import Filters from '../Filters/Filters';
import { jockeyFilterConfig } from './jockeyFilterConfig';
const JockeyFilters = ({ filter }) => {
    const [params, setParams] = useSearchParams();
    const onChange = (filter) => {
        const entries = Object.entries(filter);
        entries.forEach(([key, value]) => {
            params.set(key, String(value));
        });
        setParams(params);
    };
    return (_jsx(Filters, Object.assign({ filter: filter }, { children: jockeyFilterConfig.map((filter, idx) => !filter.hidden ? (_jsx(FilterDropdown, { onChange: onChange, title: filter.label, textFilterOptions: filter.textFilterOptions }, idx)) : null) })));
};
export default JockeyFilters;
